module.exports = __webpack_public_path__ + "img/balance_MC.4af79210.svg";